import React from "react";
import { Paper, Typography, Divider, Box, Skeleton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const BookingFareDetails = ({
  loadingFare,
  fareQuoteDetailsList = [], // Array of objects per PassengerType
  totalMealPrice = 0,
  totalBagPrice = 0,
}) => {
  // Calculate totals from fareQuoteDetailsList
  const totalBaseFare = fareQuoteDetailsList.reduce(
    (sum, item) => sum + item.BaseFare * item.PassengerCount,
    0
  );
  const totalTax = fareQuoteDetailsList.reduce(
    (sum, item) => sum + item.Tax * item.PassengerCount,
    0
  );
  const totalPassengerCount = fareQuoteDetailsList.reduce(
    (sum, item) => sum + item.PassengerCount,
    0
  );
  const serviceFees = totalBaseFare * 0.11;
  const totalAmount =
    totalBaseFare + totalTax + serviceFees + totalMealPrice + totalBagPrice;

  return (
    <Paper sx={{ p: 2, borderRadius: "10px" }}>
      <Box sx={{ mt: 1 }}>
        <Box display={"flex"} flexDirection={"row"} gap={1} mb={1}>
          <InfoOutlinedIcon sx={{ color: "red" }} />
          <Typography sx={{ color: "red" }}>
            Fare may increase/update at the time of booking.
          </Typography>
        </Box>
        <Typography
          sx={{ fontFamily: "Open Sans", fontSize: "16px", fontWeight: 700 }}
        >
          Fare Details
        </Typography>

        {loadingFare ? (
          <>
            <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
            <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
            <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
          </>
        ) : (
          // <Box>
          //   <Box
          //     sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          //   >
          //     <Typography sx={{ fontSize: "16px" }}>Base Fare</Typography>
          //     <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          //       ₹ {baseFare.toFixed(2)}
          //     </Typography>
          //   </Box>

          //   <Box
          //     sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          //   >
          //     <Typography sx={{ fontSize: "16px" }}>Taxes</Typography>
          //     <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          //       ₹ {tax.toFixed(2)}
          //     </Typography>
          //   </Box>

          //   <Box
          //     sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          //   >
          //     <Typography sx={{ fontSize: "16px" }}>Service Fees</Typography>
          //     <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          //       ₹ {serviceFees.toFixed(2)}
          //     </Typography>
          //   </Box>

          //   {totalMealPrice > 0 && (
          //     <Box
          //       sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          //     >
          //       <Typography sx={{ fontSize: "16px" }}>Meal</Typography>
          //       <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          //         ₹ {totalMealPrice.toFixed(2)}
          //       </Typography>
          //     </Box>
          //   )}

          //   {totalBagPrice > 0 && (
          //     <Box
          //       sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          //     >
          //       <Typography sx={{ fontSize: "16px" }}>Bag</Typography>
          //       <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          //         ₹ {totalBagPrice.toFixed(2)}
          //       </Typography>
          //     </Box>
          //   )}

          //   <Divider sx={{ mt: 1, mb: 1 }} />

          //   <Box
          //     sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          //   >
          //     <Typography sx={{ fontWeight: 500, fontSize: "16px" }}>
          //       Total
          //     </Typography>
          //     <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
          //       ₹ {total.toFixed(2)}
          //     </Typography>
          //   </Box>
          // </Box>
          <Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography sx={{ fontFamily: "Open Sans", fontSize: "16px" }}>
                Base Fare (x {totalPassengerCount})
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {totalBaseFare.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography sx={{ fontFamily: "Open Sans", fontSize: "16px" }}>
                Taxes
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {totalTax.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography sx={{ fontFamily: "Open Sans", fontSize: "16px" }}>
                Service Fees
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {serviceFees.toFixed(2)}
              </Typography>
            </Box>

            {totalMealPrice > 0 && (
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <Typography sx={{ fontFamily: "Open Sans", fontSize: "16px" }}>
                  Meal
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  ₹ {totalMealPrice.toFixed(2)}
                </Typography>
              </Box>
            )}

            {totalBagPrice > 0 && (
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <Typography sx={{ fontFamily: "Open Sans", fontSize: "16px" }}>
                  Bag
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  ₹ {totalBagPrice.toFixed(2)}
                </Typography>
              </Box>
            )}

            <Divider sx={{ mt: 1, mb: 1 }} />
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Total
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {totalAmount.toFixed(2)}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default BookingFareDetails;

// import React from "react";
// import { Paper, Typography, Divider, Box, Skeleton } from "@mui/material";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// const BookingFareDetails = ({
//   loadingFare,
//   publishedFare,
//   totalTaxes,
//   totalFares,
//   totalMealPrice,
//   totalBagPrice,
//   baseFare,
//   tax,
//   searchDetails,
//   passengerCount1,
//   fareQuoteDetails,
// }) => {
//   const serviceFees = (baseFare * 1.11 - baseFare).toFixed(0);

//   return (
//     <Paper sx={{ p: 2, borderRadius: "10px" }}>
//       <Box sx={{ mt: 1 }}>
//         <Box display={"flex"} flexDirection={"row"} gap={1} mb={1}>
//           <InfoOutlinedIcon sx={{ color: "red" }} />
//           <Typography sx={{ color: "red" }}>
//             Fare may increase/update at the time of booking.
//           </Typography>
//         </Box>
//         <Typography
//           sx={{ fontFamily: "Open Sans", fontSize: "16px", fontWeight: 700 }}
//         >
//           Fare Details
//         </Typography>
//         {loadingFare ? (
//           <>
//             <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
//             <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
//             <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
//           </>
//         ) : (
//           <Box>
//             <Box
//               sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
//             >
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                 }}
//               >
//                 Base Fare ( {passengerCount1} x {fareQuoteDetails?.RootBaseFare}
//                 )
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                   fontWeight: 700,
//                 }}
//               >
//                 ₹{" "}
//                 {(passengerCount1 * fareQuoteDetails?.RootBaseFare)?.toFixed(2)}
//               </Typography>
//             </Box>

//             <Box
//               sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
//             >
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                 }}
//               >
//                 Taxes
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                   fontWeight: 700,
//                 }}
//               >
//                 ₹ {(passengerCount1 * fareQuoteDetails?.RootTax)?.toFixed(2)}
//               </Typography>
//             </Box>

//             <Box
//               sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
//             >
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                 }}
//               >
//                 Service Fees
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                   fontWeight: 700,
//                 }}
//               >
//                 ₹ {fareQuoteDetails?.TarabaiCharges?.toFixed(2)}
//               </Typography>
//             </Box>

//             {totalMealPrice ? (
//               <Box
//                 sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
//               >
//                 <Typography
//                   sx={{
//                     fontFamily: "Open Sans",
//                     fontSize: "16px",
//                   }}
//                 >
//                   Meal
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontFamily: "Open Sans",
//                     fontSize: "16px",
//                     fontWeight: 700,
//                   }}
//                 >
//                   ₹ {totalMealPrice.toFixed(2)}
//                 </Typography>
//               </Box>
//             ) : (
//               <Box></Box>
//             )}

//             {totalBagPrice ? (
//               <Box
//                 sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
//               >
//                 <Typography
//                   sx={{
//                     fontFamily: "Open Sans",
//                     fontSize: "16px",
//                   }}
//                 >
//                   Bag
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontFamily: "Open Sans",
//                     fontSize: "16px",
//                     fontWeight: 700,
//                   }}
//                 >
//                   ₹ {totalBagPrice.toFixed(2)}
//                 </Typography>
//               </Box>
//             ) : (
//               <Box></Box>
//             )}
//             <Divider sx={{ mt: 1, mb: 1 }} />
//             <Box
//               sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
//             >
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                   fontWeight: 500,
//                 }}
//               >
//                 Total
//               </Typography>
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                   fontWeight: 700,
//                 }}
//               >
//                 ₹{" "}
//                 {(
//                   totalMealPrice +
//                   totalBagPrice +
//                   fareQuoteDetails?.WalletDeductAmount
//                 )?.toFixed(2)}
//               </Typography>
//             </Box>
//           </Box>
//         )}
//       </Box>
//     </Paper>
//   );
// };

// export default BookingFareDetails;
